<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (assistantTeacher) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "AssistantTeacherProcessNav",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.assistantTeacher };
  }
};
</script>
